
//41
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "Pagination1375807887",
    {"button-common-mixin":"Pagination1375807887--button-common-mixin","root":"Pagination1375807887--root","navButton":"Pagination1375807887--navButton","disabled":"Pagination1375807887--disabled","navButtonFirst":"Pagination1375807887--navButtonFirst","navButtonPrevious":"Pagination1375807887--navButtonPrevious","navButtonNext":"Pagination1375807887--navButtonNext","navButtonLast":"Pagination1375807887--navButtonLast","pageStrip":"Pagination1375807887--pageStrip","pageStripInner":"Pagination1375807887--pageStripInner","pageStripTemplate":"Pagination1375807887--pageStripTemplate","pageButton":"Pagination1375807887--pageButton","currentPage":"Pagination1375807887--currentPage","gap":"Pagination1375807887--gap","pageForm":"Pagination1375807887--pageForm","compact":"Pagination1375807887--compact Pagination1375807887--pageForm","pageInput":"Pagination1375807887--pageInput","totalPages":"Pagination1375807887--totalPages","slash":"Pagination1375807887--slash"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/pagination/Pagination.st.css
// module id = 508
// module chunks = 0